import React from 'react';
import { Box, ToggleButton, Typography } from '@mui/material';

const CourseYearFilters = ({ selectedYearFilter, onFilterChange }) => {
  // Array di configurazione per i filtri
  const filterOptions = [
    {
      value: "0",
      label: "Workshop",
      subLabel: "e Festival",
      ariaLabel: "corsi speciali"
    },
    {
      value: "1",
      label: "1°",
      subLabel: "ANNO",
      ariaLabel: "primo anno"
    },
    {
      value: "2", 
      label: "2°",
      subLabel: "ANNO",
      ariaLabel: "secondo anno"
    },
    {
      value: "3",
      label: "3°", 
      subLabel: "ANNO",
      ariaLabel: "terzo anno"
    },
    {
      value: "post-triennio",
      label: "POST",
      subLabel: "TRIENNIO", 
      ariaLabel: "post triennio"
    }
  ];

  // Stili condivisi per i ToggleButton
  const toggleButtonStyles = {
    borderRadius: '12px',
    border: 'none',
    px: { xs: 2, sm: 3 },
    py: { xs: 1, sm: 1.5 },
    fontWeight: 600,
    fontSize: { xs: '0.8rem', sm: '0.9rem' },
    textTransform: 'none',
    minWidth: { xs: 'auto', sm: '120px' },
    '&.Mui-selected': {
      backgroundColor: 'success.main',
      color: 'white',
      '&:hover': {
        backgroundColor: 'success.dark',
      }
    },
    '&:not(.Mui-selected)': {
      backgroundColor: 'grey.300',
      color: 'text.primary',
      '&:hover': {
        backgroundColor: 'grey.400',
      }
    }
  };

  return (
    <Box sx={{ mb: 4, display: 'flex', justifyContent: 'center' }}>
      <Box sx={{ 
        display: 'flex', 
        flexWrap: 'wrap',
        gap: 1,
        justifyContent: 'center',
        width: '100%',
        maxWidth: '800px',
        mx: 'auto'
      }}>
        {filterOptions.map((option) => (
          <ToggleButton
            key={option.value}
            value={option.value}
            selected={selectedYearFilter === option.value}
            onChange={() => onFilterChange(null, option.value)}
            aria-label={option.ariaLabel}
            sx={toggleButtonStyles}
          >
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="body2" sx={{ fontWeight: 700, fontSize: { xs: '1rem', sm: '1.1rem' } }}>
                {option.label}
              </Typography>
              <Typography variant="caption" sx={{ fontWeight: 600 }}>
                {option.subLabel}
              </Typography>
            </Box>
          </ToggleButton>
        ))}
      </Box>
    </Box>
  );
};

export default CourseYearFilters;
